<template>
    <div class="project_detail">
        <el-button size="small" type="primary" @click="open" class="button_78px">查看详情</el-button>
        <el-dialog
            :title="dialogType==='detail'?detail.project_name:dialogType==='edit'?'编辑项目':detail.project_name"
            :visible.sync="show" class="project_detail_dialog" append-to-body :close-on-click-modal="false"
            width="1105px" @closed="$emit('refresh',true);mark=''">
            <!--月报详情-->
            <monthFormDetail ref="monthFormDetail" @refresh="refresh"></monthFormDetail>
            <div class="detail_box" v-if="dialogType==='detail'">
                <div class="detail">
                    <div class="content">
                        <div class="title">项目基础信息</div>
                        <detailInfo :detail="detail" :years="years"></detailInfo>
                        <div class="title">项目变更</div>
                        <div class="project_manage files">
                            <div class="files_items row">
                                <div class="item long">
                                    <div class="left">项目变更情况</div>
                                    <div class="right" v-if="!shi_project_project_power.power.change">
                                        {{ initIsChange(detail.is_change) }}
                                    </div>
                                    <div class="right" v-if="shi_project_project_power.power.change">
                                        <div class="radio_group">
                                            <div :class="{radio:true,active:detail.is_change===item.value}"
                                                 v-for="item in isChange" :key="item.value"
                                                 @click="chooseChange(item.value)">
                                                <div class="icon">
                                                    <img class="default" src="../../assets/img/radio.png" alt="">
                                                    <img class="active" src="../../assets/img/radio_active.png" alt="">
                                                </div>
                                                <div class="label">{{ item.label }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item long" v-if="detail.is_change==2">
                                    <div class="left">项目变更附件</div>
                                    <div class="right file_box">
                                        <fileListComp :file_list="detail.change_files" @change="editNameBackChange"
                                                      :show_edit="shi_project_project_power.power.change!=0" />
                                        <div
                                            v-if="!shi_project_project_power.power.change&&detail.change_files.length===0">
                                            无
                                        </div>
                                        <div v-if="shi_project_project_power.power.change">
                                            <el-button size="mini" type="text" style="font-size: 14px;"
                                                       @click="updateChangeFile">添加附件
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="item long" style="justify-content: center">
                                    <el-button size="mini" type="primary" @click="changeApi"
                                               v-if="shi_project_project_power.power.change">保存变更
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div class="title" v-if="false">项目管理</div>
                        <div class="project_manage files" v-if="false">
                            <div class="files_items row">
                                <div class="item long">
                                    <div class="left">立项前期费用</div>
                                    <el-input-number size="mini" v-model="project_brfore_num" :step="1"
                                                     :disabled="!shi_project_project_power.power.upload"
                                                     :controls="false" placeholder="点击填写金额"
                                                     @blur="managementEdit"></el-input-number>
                                    万元
                                </div>
                                <div class="item" v-for="(item,index) in visibleManageFileList" :key="'index'+index">
                                    <div class="left">{{ initFileList(item.value) }}</div>
                                    <div class="right file_box">
                                        <fileListComp :file_list="item.files" @change="editNameBackManage($event,item)"
                                                      :show_edit="shi_project_project_power.power.upload!=0" />
                                        <el-button size="mini" type="text" style="margin-left: 5px;font-size: 14px;"
                                                   v-if="shi_project_project_power.power.upload"
                                                   @click="updateFile(item)">添加附件
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="btn">
                                <el-button size="mini" type="primary" class="button_88px" @click="managementEdit"
                                    v-if="$store.state.user.power[Number($store.state.user.current_user.part)].operation.project_manage">保存</el-button>
                            </div>-->
                        </div>
                        <div class="detail_item table"
                             v-if="detail.child_project_info&&detail.child_project_info.length>0">
                            <div class="title">子项目</div>
                            <el-table :data="detail.child_project_info">
                                <el-table-column type="index" label="序号" align="center"></el-table-column>
                                <el-table-column label="标题" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.child_name }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="投资金额" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.child_all_invest_num }}万元
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="(year,index) in years" :key="index" :label="year+'年投资金额'"
                                                 align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.child_year_invest_num[year] }}万元</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="detail_item table">
                            <div class="title">拨付汇总表</div>
                            <el-table :data="payment">
                                <el-table-column type="index" label="序号" align="center"></el-table-column>
                                <el-table-column label="拨付类型" align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.allocate_info ? scope.row.allocate_info.name : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="拨付金额" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.app_money }}万元
                                    </template>
                                </el-table-column>
                                <el-table-column property="app_object" label="拨付对象" align="center"></el-table-column>
                                <el-table-column label="拨付日期" align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.app_data.slice(0, 10) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center">
                                    <template slot-scope="scope">
                                        <editPayment style="margin-right: 10px"
                                                     v-if="shi_project_project_power.power.month_form"
                                                     :parent_form="{}" :child_form="scope.row"
                                                     :mark="mark===scope.$index" :all_invest_num="detail.all_invest_num"
                                                     @click.native="mark=scope.$index" @addApp="addApp"></editPayment>
                                        <paymentDetail
                                            :app_id="scope.row.app_id"></paymentDetail>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <p class="money_total">
                                <addPayment v-if="shi_project_project_power.power.month_form"
                                            :parent_form="{}" :all_invest_num="detail.all_invest_num"
                                            :mark="mark===-1" @click.native="mark=-1"
                                            @addApp="addApp"></addPayment>
                                本项目已经拨付资付总金额：{{ money_total }}万元，占比：{{ money_rate }}%
                            </p>
                        </div>
                        <div class="detail_item table">
                            <div class="table_header">
                                <div class="title">项目进展附件汇总表</div>
                                <div class="btns">
                                    <el-button type="text" v-if="shi_project_project_power.power.upload"
                                               icon="el-icon-folder-add" @click="updateProjectFile">上传文件
                                    </el-button>
                                </div>
                            </div>
                            <div class="table_box">
                                <el-table :data="projectProgressFiles" class="project_progress_table">
                                    <el-table-column type="index" label="序号" align="center"
                                                     width="200"></el-table-column>
                                    <el-table-column label="附件名称" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.fileName }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="上传人" align="center" width="160">
                                        <template slot-scope="scope">
                                            <span>{{ getUploadUserName(scope.row.upload_userid) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="上传时间" align="center" width="200">
                                        <template slot-scope="scope">
                                            <span>{{ formatUploadTime(scope.row.upload_time) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center" width="185">
                                        <template slot-scope="scope">
                                            <div class="progress_file_actions">
                                                <div class="progress_file_status"
                                                     v-if="progress_status_map[scope.row._uploadStatus]">
                                                    <span :style="{color: progress_status_map[scope.row._uploadStatus].color}">
                                                        {{ progress_status_map[scope.row._uploadStatus].text }}
                                                    </span>
                                                    <div class="remark" v-if="scope.row._uploadMsg">
                                                        {{ scope.row._uploadMsg }}
                                                    </div>
                                                </div>
                                                <el-button class="progress_file_task_remove" type="text"
                                                           v-if="scope.row._uploadStatus === 'failed'"
                                                           @click="removeUploadTask(scope.row)">删除</el-button>
                                                <el-button type="text" v-if="!scope.row._isUploadTask"
                                                           @click="previewFile(scope.row)">预览</el-button>
                                                <el-button
                                                    class="progress_file_delete"
                                                    type="text"
                                                    v-if="canDeleteProgressFile(scope.row)"
                                                    @click="deleteProjectProgressFile(scope.row)"
                                                >删除</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="detail_item table month_form">
                            <!--<div class="add_month_form">
                                <el-button size="small" type="primary" @click="addMonthForm" class="button_98px">新增月报</el-button>
                            </div>-->
                            <div class="title">项目月报</div>
                            <div class="table_box">
                                <el-table :data="formList">
                                    <el-table-column type="index" label="序号" align="center"
                                                     width="200"></el-table-column>
                                    <el-table-column label="填报月份" align="center">
                                        <template slot-scope="scope">
                                            <span
                                                v-if="scope.row.month">{{
                                                    scope.row.month.slice(0, 4)
                                                }}年{{ scope.row.month.slice(5, 7) }}月</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="月报状态" align="center" width="240">
                                        <template slot-scope="scope">
                                            <div class="month_form_status">
                                                <span :style="{color: initMonthFormStatus(scope.row.shenhe_status).color}">
                                                    {{ initMonthFormStatus(scope.row.shenhe_status).text }}
                                                </span>
                                                <div class="remark" v-if="scope.row.shenhe_remark">
                                                    备注：{{ scope.row.shenhe_remark }}
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center" width="280">
                                        <template slot-scope="scope">
                                            <monthFormAuditActions
                                                :form-id="scope.row.form_id"
                                                :month="scope.row.month"
                                                :status="scope.row.shenhe_status"
                                                @change="refresh"
                                            ></monthFormAuditActions>
                                            <editMonthForm :form_id="scope.row.form_id" :project_id="detail.project_id"
                                                           :formList="formList"
                                                           :form_month="`${scope.row.month.slice(0,4)}-${scope.row.month.slice(5,7)}`"
                                                           :project_construction_unit="detail.construction_unit"
                                                           :yearFinish="detail.year_finish"
                                                           :all_invest_num="detail.all_invest_num"
                                                           @refresh="refresh"
                                                           @editYearFinish="editYearFinish"
                                                           v-if="(((enter==1&&shi_project_project_power.power.month_form)||(enter==2&&statistics_power.power.edit))&&Number(scope.row.shenhe_status)!==1)"></editMonthForm>
                                            <el-button type="text" @click="toMonthFormDetail(scope.row.form_id)">详情
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="detail_item table" v-if="checkItems.length>0">
                            <div class="title">援青干部项目检查日志</div>
                            <div class="table_box">
                                <el-table :data="checkItems">
                                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                                    <el-table-column label="地址" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.address_obj.address }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column property="show_name" label="检查人" align="center"></el-table-column>
                                    <el-table-column property="show_time" label="检查时间" align="center"></el-table-column>
                                    <el-table-column label="操作" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" style="margin-right: 10px;"
                                                       @click="delCheck(scope.row.id)"
                                                       v-if="$store.state.user.current_user.userid===scope.row.user_info.userid">
                                                删除
                                            </el-button>
                                            <checkItemDetail :id="scope.row.id"></checkItemDetail>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="detail_item table" v-if="checkItems2.length>0">
                            <div class="title">第三方项目检查日志</div>
                            <div class="table_box">
                                <el-table :data="checkItems2">
                                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                                    <el-table-column label="地址" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.address_obj.address }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column property="show_name" label="检查人" align="center"></el-table-column>
                                    <el-table-column property="show_time" label="检查时间" align="center"></el-table-column>
                                    <el-table-column label="操作" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" style="margin-right: 10px;"
                                                       @click="delCheck(scope.row.id)"
                                                       v-if="$store.state.user.current_user.userid===scope.row.user_info.userid">
                                                删除
                                            </el-button>
                                            <checkItemDetail :id="scope.row.id"></checkItemDetail>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="detail_item report_list table" v-if="reportList.length>0">
                            <div class="title">技术报告列表</div>
                            <div class="table_box">
                                <el-table :data="reportList">
                                    <el-table-column type="index" label="序号" align="center"
                                                     width="200px"></el-table-column>
                                    <el-table-column label="技术报告名称" align="center">
                                        <template slot-scope="scope">
                                            <div class="files">
                                                <div class="file" style="" v-for="(v,k) in scope.row.file_ids"
                                                     :key="k+1" @click="previewFile(v)">{{ v.fileName }}
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="上传月度" align="center" width="200px">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.month }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="button" v-if="
                            (enter==1&&shi_project_project_power.power.month_form)
                            ||
                            (enter==1&&shi_project_project_power.power.edit)
                            ||
                            (enter==1&&shi_project_project_power.power.stop)
                            ||
                            (enter==1&&shi_project_project_power.power.delete)
                            ||
                            (enter==2&&statistics_power.power.edit)
                        ">
                        <el-button size="small" type="primary" @click="addMonthForm" class="button_98px"
                                   v-if="(enter==1&&shi_project_project_power.power.month_form)||(enter==2&&statistics_power.power.edit)">
                            新增月报
                        </el-button>
                        <el-button size="small" type="primary" @click="dialogType='edit'" class="button_98px"
                                   v-if="((enter==1&&shi_project_project_power.power.edit)||(enter==2&&statistics_power.power.edit))&&$store.state.user.project_edit_data.project_edit==1">
                            编辑项目
                        </el-button>
                        <el-button size="small" type="primary" @click="stopProject(detail.project_id)"
                                   class="button_98px" :disabled="detail.project_status==7"
                                   v-if="(enter==1&&shi_project_project_power.power.stop)||(enter==2&&statistics_power.power.edit)">
                            终止项目
                        </el-button>
                        <el-button size="small" type="primary" @click="deleteProject(detail.project_id)"
                                   class="button_98px"
                                   v-if="(enter==1&&shi_project_project_power.power.delete)||(enter==2&&statistics_power.power.edit)">
                            删除项目
                        </el-button>
                        <!--<el-button v-if="years.length===1&&$store.state.user.power[Number($store.state.user.current_user.part)].operation.finish_project"
                            size="small" type="primary" @click="yearFinish(years[0])" class="button_98px" :disabled="finish_info.indexOf(years[0])!==-1">完成项目</el-button>
                        <el-dropdown trigger="click" v-if="years.length>1&&$store.state.user.power[Number($store.state.user.current_user.part)].operation.finish_project"
                            popper-class="global_select_popper" style="margin-left: 10px;" @command="yearFinish">
                            <el-button size="small" type="primary" class="button_98px">完成项目</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(year,index) in years" :key="index" :command="year" :disabled="finish_info.indexOf(year)!==-1">{{year}}年度</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>-->
                    </div>
                </div>
            </div>
            <!--编辑项目-->
            <editProject v-if="dialogType==='edit'" :detail="detail" :prop_years="years" :enter="enter"
                         @change="detailChange"
                         @back="back"></editProject>
            <!--录入月报表-->
            <addMonthForm ref="addMonthForm" @refresh="refresh" :yearFinish="detail.year_finish"
                          :all_invest_num="detail.all_invest_num" @editYearFinish="editYearFinish"></addMonthForm>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/methods/index';
import computedData from '@/mixins/computedData.js';
import monthFormDetail from '@c/project/month_form/month_form_detail.vue';
import editProject from '@c/project/edit_project.vue';
import addMonthForm from '@c/project/month_form/add_month_form.vue';
import editMonthForm from '@c/project/month_form/edit_month_form.vue';
import monthFormAuditActions from '@c/project/month_form/month_form_audit_actions.vue';
import dingDisk from '@/utils/ding_disk';
import myPublic from '@/utils/public';
import paymentDetail from '@c/project/payment/payment_detail.vue';
import checkItemDetail from '@c/project/check_item_detail/check_item_detail.vue';
import addPayment from "@c/project/payment/add_payment.vue";
import editPayment from '@c/project/payment/edit_payment.vue';
import fileListComp from '@/components/file/index.vue'
import detailInfo from './detail_info/index.vue'

//项目管理初始化数据
const createDefaultProjectManageFiles = () => ([
    {value: 'before', files: []},
    {value: 'process', files: []},
    {value: 'check', files: []},
    {value: 'monthly', files: []},
    {value: 'log', files: []},
]);

//项目管理附件
const normalizeProjectManageFiles = (list = []) => {
    let sourceList = Array.isArray(list) ? list : [];
    let defaultList = createDefaultProjectManageFiles();
    let defaultValues = defaultList.map(item => item.value);
    let currentMap = new Map();

    sourceList.forEach(item => {
        if (!item || !item.value) return;
        currentMap.set(item.value, {
            value: item.value,
            files: Array.isArray(item.files) ? item.files : []
        });
    });

    let normalList = defaultList.map(item => {
        return currentMap.get(item.value) || item;
    });

    let extraList = sourceList.filter(item => {
        return item && item.value && !defaultValues.includes(item.value);
    }).map(item => ({
        value: item.value,
        files: Array.isArray(item.files) ? item.files : []
    }));

    return [...normalList, ...extraList];
};

//附件汇总表上传状态
const PROGRESS_FILE_STATUS = {
    uploading: {text: '上传中', color: '#E6A23C'},
    failed: {text: '上传失败', color: '#F56C6C'},
};

//上传占位行自增id
let uploadTaskSeq = 0;

//浅拷贝数据
const cloneJsonData = (data) => JSON.parse(JSON.stringify(data || {}));

// 附件汇总表由多个来源拼装而成，这里给每条附件补上来源信息，便于删除时回写到正确的业务对象。
const buildProjectProgressFile = (file, source = {}) => ({
    ...file,
    _sourceType: source.type || '',
    _sourceId: source.id,
    _sourceLabel: source.label || '',
    _sourceFileKey: source.fileKey || 'fileId',
});

//上传时间转换为时间戳
const getUploadTimeValue = (upload_time) => {
    if (!upload_time) return Number.MIN_SAFE_INTEGER;
    let normalizedTime = upload_time;
    if (typeof normalizedTime === 'string') {
        normalizedTime = normalizedTime.trim();
        if (/^\d+$/.test(normalizedTime)) {
            normalizedTime = Number(normalizedTime);
            if (normalizedTime < 10000000000) normalizedTime *= 1000;
        } else if (normalizedTime.indexOf('T') === -1) {
            normalizedTime = normalizedTime.replace(/-/g, '/');
        }
    }
    let time = new Date(normalizedTime).getTime();
    return Number.isNaN(time) ? Number.MIN_SAFE_INTEGER : time;
};

//上传时间排序
const sortFilesByUploadTimeAsc = (files = []) => files
    .map((file, index) => ({file, index}))
    .sort((a, b) => {
        let timeDiff = getUploadTimeValue(a.file.upload_time) - getUploadTimeValue(b.file.upload_time);
        return timeDiff || a.index - b.index;
    })
    .map(item => item.file);

export default {
    mixins: [computedData],
    components: {
        monthFormDetail,
        editProject,
        addMonthForm,
        paymentDetail,
        editMonthForm,
        monthFormAuditActions,
        checkItemDetail,
        addPayment,
        editPayment,
        fileListComp,
        detailInfo
    },
    props: ['project_detail', 'enter'],//enter:1表示从市项目管理点进来,enter:2表示从统计分析列表中点进来
    data() {
        return {
            show: false, dialogType: 'detail',//detail项目详情,edit编辑项目
            years: [], detail: {}, formList: [], finish_info: [],//项目已完成年度,年度集合
            fileList: createDefaultProjectManageFiles(), project_brfore_num: undefined, file_change: false,//附件是否变更,如果有则执行managementEdit();
            payment: [],//项目拨付款
            checkItems: [], checkItems2: [],//checkItems援青干部日常检查记录 , checkItems2第三方检查日志
            monthFiles: [],//项目月报附件集合
            uploadUserMap: {},
            uploadTasks: [],//项目进展附件上传占位行
            isChange: [
                {value: 1, label: '未变更'},
                {value: 2, label: '已变更'}
            ],
            reportList: [],
            money_total: 0,//项目已拨付资金总额
            money_rate: 0,//项目已拨付资金占比(已拨付总金额 / 实际投资金额)
            mark: '',//项目拨付款识别用的,0,1,2等数字为编辑的项目拨付款index,-1为新建
        };
    },
    computed: {
        shi_project_project_power() {
            return this.$store.state.user.current_user.shi_project_project_power;
        },
        statistics_power() {
            return this.$store.state.user.current_user.statistics_power;
        },
        //附件上传状态文案
        progress_status_map() {
            return PROGRESS_FILE_STATUS;
        },
        //项目管理信息显示
        visibleManageFileList() {
            return this.fileList.filter(item => item.value !== 'project');
        },
        //拨付款附件信息
        paymentFiles() {
            return this.payment.reduce((files, item) => {
                if (Array.isArray(item.app_file_ids) && item.app_file_ids.length > 0) {
                    item.app_file_ids.forEach(file => {
                        files.push(buildProjectProgressFile(file, {
                            type: 'payment',
                            id: item.app_id,
                            label: `${item.allocate_info ? item.allocate_info.name : '项目拨付款'} ${item.app_object || ''}`.trim(),
                        }));
                    });
                }
                return files;
            }, []);
        },
        //项目进展附件汇总表
        projectProgressFiles() {
            let projectFiles = this.getProjectManageFiles('project')
                .map(file => buildProjectProgressFile(file, {
                    type: 'project',
                    id: this.detail.project_id,
                    label: '项目进展附件',
                }));
            let taskRows = this.uploadTasks.map(task => {
                return buildProjectProgressFile(task, {
                    type: 'project',
                    id: this.detail.project_id,
                    label: '项目进展附件',
                });
            }).map(task => ({...task, _isUploadTask: true, _uploadStatus: task.status}));
            return [...sortFilesByUploadTimeAsc([...this.paymentFiles, ...this.monthFiles, ...projectFiles]), ...taskRows];
        }
    },
    methods: {
        open() {
            this.dialogType = 'detail';
            this.uploadTasks = [];
            this.projectDetail();
            this.show = true;
        },
        back() {
            this.dialogType = 'detail';
        },
        //编辑月报后重新刷新月报列表和项目拨付款列表
        refresh() {
            this.formLists();
            this.appLists();
        },
        //保存项目管理附件和立项前期费用
        managementEdit() {
            let param = {
                project_id: this.detail.project_id,
                project_management: JSON.stringify(this.fileList)
            };
            if (this.project_brfore_num !== null && this.project_brfore_num !== undefined && this.project_brfore_num !== '') {
                param.project_brfore_num = this.project_brfore_num * 10000;
            } else {
                param.project_brfore_num = '';
            }
            if (JSON.stringify(this.fileList) === this.detail.project_management && param.project_brfore_num === this.detail.project_brfore_num) {
                // this.$message.error('项目管理相关信息未修改无法保存!');
                return;
            }
            api.project.managementEdit(param).then(res => {
                if (res.data.state == 1) {
                    this.$message({
                        message: '项目管理信息保存成功',
                        type: 'success'
                    });
                    this.detail.project_management = param.project_management;
                    this.detail.project_brfore_num = param.project_brfore_num;
                }
            });
        },
        projectDetail() {
            this.detail = {};
            this.years = [];
            this.finish_info = [];
            api.project.projectDetail({project_id: this.project_detail.project_id}).then(res => {
                if (res.data) {
                    let detail = res.data.rows || {};
                    if (!detail.contact_group) detail.contact_group = {};
                    if (!detail.contact_group_fuze) detail.contact_group_fuze = {};
                    if (detail.finish_info) {
                        detail.finish_info.forEach(item => {
                            if (item.finish_year) this.finish_info.push(Number(item.finish_year.slice(0, 4)));
                        });
                    }
                    if (detail.all_invest_num) {
                        detail.all_invest_num = Number(detail.all_invest_num) / 10000;
                    }
                    if (detail.real_num) {
                        detail.real_num = Number(detail.real_num) / 10000;
                    }
                    if (detail.year_invest_num) {
                        detail.year_invest_num = JSON.parse(detail.year_invest_num);
                        for (let year in detail.year_invest_num) {
                            detail.year_invest_num[year] = Number(detail.year_invest_num[year]) / 10000;
                        }
                    } else {
                        detail.year_invest_num = {};
                    }
                    if (detail.child_project_info) {
                        detail.child_project_info = JSON.parse(detail.child_project_info);
                        detail.child_project_info.forEach(child => {
                            child.child_all_invest_num = Number(child.child_all_invest_num) / 10000;
                            for (let year in child.child_year_invest_num) {
                                child.child_year_invest_num[year] = Number(child.child_year_invest_num[year]) / 10000;
                            }
                        });
                    } else {
                        detail.child_project_info = [];
                    }
                    if (myPublic.isJsonString(detail.project_management)) {
                        this.fileList = normalizeProjectManageFiles(JSON.parse(detail.project_management));
                        detail.project_management = JSON.stringify(this.fileList);
                    } else {
                        this.fileList = createDefaultProjectManageFiles();
                        detail.project_management = JSON.stringify(this.fileList);
                    }
                    if (detail.project_brfore_num !== null && detail.project_brfore_num !== undefined && detail.project_brfore_num !== '') {
                        this.project_brfore_num = Number(detail.project_brfore_num) / 10000;
                    } else {
                        this.project_brfore_num = undefined;
                        detail.project_brfore_num = '';
                    }
                    let regN = /\n/g;
                    let regR = /\r/g;
                    //项目概况
                    if (detail.project_profile) {
                        detail.new_project_profile = detail.project_profile.replace(regN, "<br />").replace(regR, "<br />");
                    }
                    //项目审计
                    if (detail.audit) {
                        detail.new_audit = detail.audit.replace(regN, "<br />").replace(regR, "<br />");
                    }
                    //项目检查
                    if (detail.check) {
                        detail.new_check = detail.check.replace(regN, "<br />").replace(regR, "<br />");
                    }
                    //项目评估
                    if (detail.assess) {
                        detail.new_assess = detail.assess.replace(regN, "<br />").replace(regR, "<br />");
                    }
                    //项目变更情况
                    if (!detail.is_change) {
                        detail.is_change = 1;
                    }
                    //项目变更附件
                    if (myPublic.isJsonString(detail.change_files)) {
                        detail.change_files = JSON.parse(detail.change_files);
                    } else {
                        detail.change_files = [];
                    }
                    // console.log(detail,'detail')
                    this.detail = detail;
                    if (detail.start_time && detail.end_time) {
                        detail.start_time = myPublic.dateFormat(detail.start_time, 'YYYY-MM-DD');
                        detail.end_time = myPublic.dateFormat(detail.end_time, 'YYYY-MM-DD');
                        detail.time = [
                            detail.start_time.slice(0, 4) + '-' + detail.start_time.slice(5, 7),
                            detail.end_time.slice(0, 4) + '-' + detail.end_time.slice(5, 7)
                        ];
                        let start = detail.start_time.slice(0, 4);
                        let end = detail.end_time.slice(0, 4);
                        for (let i = start; i <= end; i++) {
                            this.years.push(Number(i));
                        }
                    }
                    this.appLists();
                    this.formLists();
                    this.getCheckItems();
                    this.getCheckItems2();
                    this.getReportList();
                }
            });
        },
        //新增月报
        addMonthForm() {
            this.$refs['addMonthForm'].show = true;
            this.$refs['addMonthForm'].project_detail = this.detail;
            this.$refs['addMonthForm'].formList = this.formList;
        },
        //月报列表
        formLists() {
            this.formList = [];
            this.monthFiles = [];
            let param = {project_id: this.project_detail.project_id, page: 1, pagesize: 200};
            return api.project.formLists(param).then(res => {
                if (res.data) {
                    this.formList = res.data.lists || [];
                    this.formList.forEach(item => {
                        if (myPublic.isJsonString(item.project_file_ids)) {
                            item.files = JSON.parse(item.project_file_ids);
                        } else {
                            item.files = [];
                        }
                        item.files.forEach(file => {
                            // 月报附件也统一转换成汇总表结构，后续删除时根据 form_id 精确回写。
                            this.monthFiles.push(buildProjectProgressFile(file, {
                                type: 'month',
                                id: item.form_id,
                                label: `${item.month || ''}月报附件`,
                            }));
                        });
                        if (item.implementation_before && new Date(item.month).getFullYear() === new Date().getFullYear()) {
                            let implementation_before = item.implementation_before.split(',');
                            item.implementation_before = implementation_before.map(Number);
                        } else {
                            item.implementation_before = [];
                        }
                        if (item.implementation_after && new Date(item.month).getFullYear() === new Date().getFullYear()) {
                            let implementation_after = item.implementation_after.split(',');
                            item.implementation_after = implementation_after.map(Number);
                        } else {
                            item.implementation_after = [];
                        }
                    });
                }
            });
        },
        //项目拨付款列表
        async appLists() {
            this.payment = [];
            return api.project.appLists({project_id: this.detail.project_id, page: 1, pagesize: 200}).then(res => {
                if (res.data) {
                    this.payment = res.data.lists || [];
                    this.money_total = 0;
                    this.money_rate = 0;
                    if (this.payment.length) {
                        this.payment.forEach(item => {
                            if (!isNaN(Number(item.app_money))) {
                                this.money_total = this.money_total + Number(item.app_money);
                            }
                            if (myPublic.isJsonString(item.app_file_ids)) {
                                item.app_file_ids = JSON.parse(item.app_file_ids);
                            } else {
                                item.app_file_ids = [];
                            }
                            if (item.app_money) {
                                item.app_money = Number(item.app_money) / 10000;
                            }
                        });
                        this.money_total = this.money_total / 10000;
                        this.money_rate = ((this.money_total / this.detail.real_num) * 100).toFixed(2);
                    }
                }
            });
        },
        //日常检查记录列表
        getCheckItems() {
            this.checkItems = [];
            api.project.getCheckItems({
                project_id: this.detail.project_id,
                page: 1,
                pagesize: 200,
                type: 1
            }).then(res => {
                if (res.data) {
                    this.checkItems = res.data.lists || [];
                    this.checkItems.forEach(item => {
                        if (myPublic.isJsonString(item.address)) {
                            item.address_obj = JSON.parse(item.address);
                        }
                        if (item.create_time) {
                            item.show_time = item.create_time.slice(0, -3);
                        }
                        item.show_name = '无';
                        if (item.user_info.nickname) {
                            item.show_name = item.user_info.nickname;
                        }
                    });
                }
            });
        },
        getCheckItems2() {
            this.checkItems2 = [];
            api.project.getCheckItems({
                project_id: this.detail.project_id,
                page: 1,
                pagesize: 200,
                type: 2
            }).then(res => {
                if (res.data) {
                    this.checkItems2 = res.data.lists || [];
                    this.checkItems2.forEach(item => {
                        if (myPublic.isJsonString(item.address)) {
                            item.address_obj = JSON.parse(item.address);
                        }
                        if (item.create_time) {
                            item.show_time = item.create_time.slice(0, -3);
                        }
                        item.show_name = '无';
                        if (item.user_info.nickname) {
                            item.show_name = item.user_info.nickname;
                        }
                    });
                }
            });
        },
        delCheck(id) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, '确定要删除该检查日志吗?'),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        api.project.checkItemDel({id: id}).then(res => {
                            if (res.data.state == 1) {
                                this.$message({
                                    message: '检查日志删除成功',
                                    type: 'success'
                                });
                                this.click_del = true;
                                this.open();
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).catch(() => {

            });
        },
        //上传报告列表
        getReportList() {
            this.reportList = [];
            let param = {
                page: 1,
                pagesize: 999,
                project_id: this.detail.project_id
            };
            api.project.reportList(param).then(res => {
                if (res.data) {
                    let list = res.data.lists || [];
                    list.forEach(item => {
                        if (myPublic.isJsonString(item.file_ids)) {
                            item.file_ids = JSON.parse(item.file_ids);
                        } else {
                            item.file_ids = [];
                        }
                    });
                    this.reportList = list;
                }
            });
        },
        yearFinish(year) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, `确定要完成${year}年度项目吗?`),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        api.project.yearFinish({
                            project_id: this.project_detail.project_id,
                            year: year
                        }).then(res => {
                            if (res.data.state == 1) {
                                this.$message({
                                    message: `${year}年度完成成功`,
                                    type: 'success'
                                });
                                this.finish_info.push(year);
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).catch(() => {

            });
        },
        toMonthFormDetail(form_id) {
            this.$refs['monthFormDetail'].show = true;
            this.$refs['monthFormDetail'].form_id = form_id;
        },
        //编辑项目后传值回来
        detailChange(years, detail) {
            this.years = years;
            this.detail = detail;
            this.dialogType = 'detail';
            // this.tab = 'detail';
        },
        //终止项目
        stopProject(id) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, '确定要终止该项目吗?'),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        api.project.stopProject({project_id: id}).then(res => {
                            if (res.data.state == 1) {
                                this.$message({
                                    message: '项目终止成功',
                                    type: 'success'
                                });
                                this.$emit('refresh');
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).catch(() => {

            });
        },
        deleteProject(id) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, '确定要删除该项目吗?'),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        api.project.deleteProject({project_id: id}).then(res => {
                            if (res.data.state == 1) {
                                this.$message({
                                    message: '项目删除成功',
                                    type: 'success'
                                });
                                this.$emit('refresh');
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).catch(() => {

            });
        },
        //上传附件
        updateFile(item) {
            dingDisk.dingDiskUpdate(res => {
                item.files = [...item.files, ...res.data];
                this.file_change = true;
            });
        },
        //获取项目管理附件
        getProjectManageFiles(value) {
            let currentItem = this.fileList.find(item => item.value === value);
            return currentItem && Array.isArray(currentItem.files) ? currentItem.files : [];
        },
        //上传项目管理附件.
        updateProjectFile() {
            dingDisk.dingDiskUpdate(async res => {
                let files = Array.isArray(res.data) ? res.data : [];
                let nextFileList = this.createFileListWithProjectFiles([
                    ...this.getProjectManageFiles('project'),
                    ...files
                ]);
                try {
                    await this.saveProjectManageFiles(nextFileList);
                    this.finishUploadTask(files);
                } catch (error) {
                    this.failUploadTask(files, '附件保存失败，请重试');
                }
            }, 9, {
                onSelect: files => this.startUploadTask(files),
                onFail: (files, msg) => this.failUploadTask(files, msg)
            });
        },
        //生成新的项目管理附件列表
        createFileListWithProjectFiles(files = []) {
            let nextFileList = cloneJsonData(this.fileList);
            let currentItem = nextFileList.find(item => item.value === 'project');
            if (currentItem) {
                currentItem.files = files;
            } else {
                nextFileList.push({value: 'project', files: files});
            }
            return nextFileList;
        },
        //保存项目管理附件,成功后再回写本地数据,避免失败时列表出现脏数据
        async saveProjectManageFiles(nextFileList) {
            let param = {
                project_id: this.detail.project_id,
                project_management: JSON.stringify(nextFileList),
                project_brfore_num: this.project_brfore_num !== null && this.project_brfore_num !== undefined && this.project_brfore_num !== '' ? this.project_brfore_num * 10000 : ''
            };
            let res = await api.project.managementEdit(param);
            if (res?.data?.state != 1) {
                throw new Error('project_file_save_failed');
            }
            this.fileList = nextFileList;
            this.detail.project_management = param.project_management;
            this.detail.project_brfore_num = param.project_brfore_num;
        },
        //选中文件后先插入上传中占位行
        startUploadTask(files = []) {
            files.forEach(file => {
                this.uploadTasks.push({
                    id: ++uploadTaskSeq,
                    fileName: file.fileName,
                    status: 'uploading',
                    msg: ''
                });
            });
        },
        //上传并保存成功,移除占位行,附件行由列表数据正常展示
        finishUploadTask(files = []) {
            files.forEach(file => {
                let taskIndex = this.uploadTasks.findIndex(task => task.fileName === file.fileName);
                if (taskIndex !== -1) {
                    this.uploadTasks.splice(taskIndex, 1);
                }
            });
        },
        //上传或保存失败,占位行保留并展示失败原因
        failUploadTask(files = [], msg = '上传失败') {
            files.forEach(file => {
                let task = this.uploadTasks.find(item => {
                    return item.fileName === file.fileName && item.status === 'uploading';
                });
                if (task) {
                    task.status = 'failed';
                    task.msg = msg;
                }
            });
        },
        //删除上传失败的占位行,这类数据没有落库,直接从列表移除
        removeUploadTask(row) {
            let taskIndex = this.uploadTasks.findIndex(task => task.id === row.id);
            if (taskIndex !== -1) {
                this.uploadTasks.splice(taskIndex, 1);
            }
        },
        //通过人员id获取人员信息
        async syncUploadUserMap(list = []) {
            let ids = [...new Set(list.map(item => `${item?.upload_userid || ''}`).filter(Boolean))];
            let missingIds = ids.filter(id => this.uploadUserMap[id] === undefined);
            if (missingIds.length === 0) return;
            let res = await api.user.GetInfoByIds({
                ids: missingIds.join(','),
                type: 1
            });
            if (res?.data?.state == 1) {
                let uploadUserMap = {...this.uploadUserMap};
                let userList = res.data.list || [];
                userList.forEach(item => {
                    uploadUserMap[`${item.userid}`] = item.nickname || item.name || '';
                });
                missingIds.forEach(id => {
                    if (uploadUserMap[id] === undefined) {
                        uploadUserMap[id] = '';
                    }
                });
                this.uploadUserMap = uploadUserMap;
            }
        },
        //回显上传人
        getUploadUserName(upload_userid) {
            if (!upload_userid) return '--';
            return this.uploadUserMap[`${upload_userid}`] || '--';
        },
        //回显上传时间
        formatUploadTime(upload_time) {
            if (!upload_time) return '--';
            return myPublic.dateFormat(upload_time, 'YYYY-MM-DD HH:mm') || '--';
        },
        //月报审核状态
        initMonthFormStatus(status) {
            switch (Number(status)) {
                case -1:
                    return {
                        text: '审核中',
                        color: '#E6A23C'
                    };
                case 1:
                    return {
                        text: '通过',
                        color: '#67C23A'
                    };
                case 2:
                    return {
                        text: '退回',
                        color: '#F56C6C'
                    };
                default:
                    return {
                        text: '--',
                        color: '#909399'
                    };
            }
        },
        //是否允许删除
        canDeleteProgressFile(row) {
            let currentUserId = this.$store.state.user.current_user.userid;
            return !!(this.shi_project_project_power
                && this.shi_project_project_power.power
                && this.shi_project_project_power.power.upload
                && row
                && row._sourceType === 'project'
                && row.upload_userid
                && String(row.upload_userid) === String(currentUserId));
        },
        //获取项目基本信息保存参数
        getProjectBaseSaveParam() {
            let param = {
                project_id: this.detail.project_id,
                project_name: this.detail.project_name,
                area: this.detail.area,
                address: this.detail.address,
                all_invest_num: this.detail.all_invest_num * 10000,
                year_invest_num: cloneJsonData(this.detail.year_invest_num),
                start_time: this.detail.time[0],
                end_time: this.detail.time[1],
                build_quality: this.detail.build_quality,
                project_quality: this.detail.project_quality,
                project_genre: this.detail.project_genre,
                project_profile: this.detail.project_profile,
                contact_group: this.detail.contact_group ? this.detail.contact_group.department_id : '',
                contact_group_fuze: this.detail.contact_group_fuze ? this.detail.contact_group_fuze.userid : '',
                project_unit: this.detail.project_unit,
                project_fuze: this.detail.project_fuze,
                fuze_phone: this.detail.fuze_phone,
                is_change: this.detail.is_change,
                change_files: JSON.stringify(this.detail.change_files),
                fgld: this.detail.fgld || '',
                fgld_phone: this.detail.fgld_phone || '',
            };
            if (this.detail.real_num === '' || this.detail.real_num === undefined || this.detail.real_num === null) {
                param.real_num = param.all_invest_num;
            } else {
                param.real_num = this.detail.real_num * 10000;
            }
            for (let year in param.year_invest_num) {
                param.year_invest_num[year] = Number(param.year_invest_num[year]) * 10000;
            }
            param.year_invest_num = JSON.stringify(param.year_invest_num);
            param.child_project_info = [];
            let child_project_info = cloneJsonData(this.detail.child_project_info);
            child_project_info.forEach(item => {
                item.child_all_invest_num = Number(item.child_all_invest_num) * 10000;
                for (let year in item.child_year_invest_num) {
                    item.child_year_invest_num[year] = Number(item.child_year_invest_num[year]) * 10000;
                }
                param.child_project_info.push({
                    child_name: item.child_name,
                    child_all_invest_num: item.child_all_invest_num,
                    child_year_invest_num: item.child_year_invest_num
                });
            });
            param.child_project_info = JSON.stringify(param.child_project_info);
            return param;
        },
        //从附件数组里移除命中的附件，再走原有保存接口。
        removeMatchedFile(list = [], targetRow = {}) {
            let matched = false;
            let nextList = list.filter(file => {
                if (!file) return false;
                let sameFileId = targetRow.fileId && file.fileId && String(file.fileId) === String(targetRow.fileId);
                let sameWebFile = targetRow.url && file.url && targetRow.fileName === file.fileName && targetRow.url === file.url;
                if (sameFileId || sameWebFile) {
                    matched = true;
                    return false;
                }
                return true;
            });
            return {
                matched,
                list: nextList
            };
        },
        //保存删除项目附件
        async saveDeletedProjectFile(row) {
            let currentFiles = this.getProjectManageFiles('project');
            let {matched, list} = this.removeMatchedFile(currentFiles, row);
            if (!matched) {
                throw new Error('project_file_not_found');
            }
            await this.saveProjectManageFiles(this.createFileListWithProjectFiles(list));
        },
        //删除项目进度附件
        async deleteProjectProgressFile(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, '确定要删除该项目进展附件吗？'),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: async (action, instance, done) => {
                    if (action !== 'confirm') {
                        done();
                        return;
                    }
                    try {
                        await this.saveDeletedProjectFile(row);
                        this.$message({
                            message: '附件删除成功',
                            type: 'success'
                        });
                        await Promise.all([this.formLists(), this.appLists()]);
                        done();
                    } catch (error) {
                        this.$message.error('附件删除失败，请重试');
                    }
                }
            }).catch(() => {

            });
        },
        //预览附件
        previewFile(file_info) {
            dingDisk.previewFile(file_info);
        },
        //项目管理下的附件改名
        editNameBackManage(list, item) {
            this.$set(item, 'files', list);
            this.managementEdit();
        },
        //选择项目已变更或未变更
        chooseChange(value) {
            if (this.detail.is_change === value) return;
            this.detail.is_change = value;
        },
        //删除项目变更附件
        delChangeFile(file_index) {
            this.detail.change_files.splice(file_index, 1);
        },
        //上传项目变更附件
        updateChangeFile() {
            dingDisk.dingDiskUpdate(res => {
                this.detail.change_files = [...this.detail.change_files, ...res.data];
            });
        },
        //项目变更下的附件修改名字
        editNameBackChange(file_list) {
            this.detail.change_files = file_list;
        },
        //项目变更后执行的编辑项目api
        changeApi() {
            let param = this.getProjectBaseSaveParam();
            api.project.addProject(param).then(res => {
                if (res.data.state == 1) {
                    this.$message({
                        message: '变更项目成功',
                        type: 'success'
                    });
                }
            });
        },
        //修改本年度项目完工情况
        editYearFinish(val) {
            this.detail.year_finish = JSON.parse(JSON.stringify(val));
        },
        //添加项目拨付款
        addApp(param) {
            let saveParam = JSON.parse(JSON.stringify(param));
            delete saveParam.allocate_info;
            saveParam.app_file_ids = JSON.stringify(saveParam.app_file_ids);
            saveParam.app_money = Number(saveParam.app_money) * 10000;
            api.project.addApp({
                ...saveParam,
                project_id: this.detail.project_id,
            }).then(res => {
                if (res.data.state == 1) {
                    this.$message({
                        message: `${saveParam.app_id ? '编辑' : '添加'}项目拨付款成功`,
                        type: 'success'
                    });
                    this.mark = '';
                    this.appLists();
                }
            });
        }
    },
    watch: {
        //附件变更后同步获取上传人信息
        projectProgressFiles: {
            handler: function (list) {
                this.syncUploadUserMap(list);
            },
            immediate: true
        },
        file_change: {
            handler: function (val) {
                if (val) {
                    this.managementEdit();
                    this.file_change = false;
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="less">
div.project_detail_dialog {
    .month_form_status {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 1.4;

        .remark {
            margin-top: 2px;
            font-size: 12px;
            color: #909399;
            word-break: break-all;
        }
    }

    .table_header {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .btns {
            position: absolute;
            right: 0;
        }
    }

    .project_progress_table {
        .progress_file_actions {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .progress_file_status {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.4;

            & > span {
                white-space: nowrap;
            }

            .remark {
                margin-top: 2px;
                font-size: 12px;
                color: #909399;
                word-break: break-all;
            }
        }

        .progress_file_task_remove {
            margin-left: 10px;
            color: #F56C6C;
        }

        .progress_file_delete {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #F56C6C;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.3s ease;
        }

        .el-table__body tr:hover .progress_file_delete {
            opacity: 1;
            pointer-events: auto;
        }
    }
}
</style>
